import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent {
  title = 'Ari\'s Chess Home';
}



// WEBPACK FOOTER //
// /workspace/chess.arska.org/chess/src/app/app.component.ts